import React, { useEffect, useState } from "react";
import packageJson from '../package.json';
import "./App.css";
import Chatbox from "./Components/ChatBox/ChatBox";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";



export const handleToken = () => {
  try {
    const homepageURL = packageJson.homepage;
    const formData = new FormData(); 
    formData.append("action", "oag_create_user");
    // const header = {
    //   authorization:
    //     "6892a6cb-93d6-4500-99d4-e028c7f8c3dd:sk-MTRkZTdmODctY2VmZC00OTUzLWE1NzYtNGRiYjU5N2I5MGUx",
    // };
    axios
      .post(
        homepageURL+"wp-admin/admin-ajax.php",
        formData,        
      )
      .then((response) => {
        // console.log(response);
        // console.log(response?.data);
        // console.log(response?.data?.data?.token);
        if (response?.data) {
          //localStorage.setItem("userDetails", JSON.stringify(response?.data));
          const chat_form: any = document.getElementById("chat_form");
          if(response?.data?.success){
            if(response?.data?.data?.token)
              {
                  const token =response?.data?.data?.token;
                  localStorage.setItem("token", token);
                  chat_form.style.display = "inherit";
              }

          }
          
          
        }
      })
      .catch((error) => {        
       
        const chat_form: any = document.getElementById("chat_form");
        const login_overlay: any = document.getElementById("loginOverlay");
        if(error.response.status == 403)
          {
            //toast.error("Unauthorized access. Please login and try again.");            
             chat_form.style.display = "none";
             login_overlay.style.display = "flex";
          }else{
            toast.error("Something went wrong");
            chat_form.style.display = "inherit";
            login_overlay.style.display = "none";
          }
      });
  } catch (error) {
    throw new Error("Failed to fetch user details: " + error);
  }
};
export interface UserDetails {
  project: string;
  user_id: string;
  api_key: string;
}
function App() {
  useEffect(() => {
    // const token = localStorage.getItem("token");
    // if (!token) {
    //   handleToken()
    // }
    handleToken()
  }, []);

  return (
    <div className="App">
      <Router basename="/">
        <Routes>
          <Route path="/" element={<Chatbox />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
